import React from 'react';
import { useTranslations } from '@fshr/context/i18n-context';

export const DepartureCard: React.FC = () => {
	const t = useTranslations();
	return (
		<div
			className="flex items-start spacing-inline-xs relative"
			role="listitem"
			aria-label={t('Departure Card')}
		>
			<div className="flex flex-col h-full">
				{/* Timeline dot and line */}
				<div
					className="absolute left-[3px] top-0 bottom-0 flex flex-col items-center"
					aria-hidden={true}
				>
					{/* Dot */}
					<div className="relative flex h-2 w-2">
						<div className="absolute h-2 w-2 rounded-full bg-[rgb(77,77,77,0.45)]" />
					</div>
				</div>
			</div>

			{/* Content */}
			<div className="flex-1 pl-100 pb-200">
				{/* Card */}
				<div className="rounded bg-surface-raised-subtle p-200 border border-border-subtle">
					<h3 className="text-subtitle2 text-text-primary">{t('Departure')}</h3>
				</div>
			</div>
		</div>
	);
};
